/** All onboarding statuses */
export enum OnboardingStatusType {
  /** Заполнение анкеты (X%) */
  FillingOut = 'FillingOut',
  /** Ожидание подтверждения оплаты */
  AwaitingPaymentConfirmation = 'AwaitingPaymentConfirmation',
  /** Ожидание проверки на корректность */
  AwaitingValidation = 'AwaitingValidation',
  /** Проверка на корректность */
  ValidationCheck = 'ValidationCheck',
  /** Ожидание Compliance проверки */
  AwaitingComplianceCheck = 'AwaitingComplianceCheck',
  /** Compliance проверка */
  ComplianceCheck = 'ComplianceCheck',
  /** Ожидание проверки ПОД/ФТ */
  AwaitingAmlCftCheck = 'AwaitingAmlCftCheck',
  /** Проверка ПОД/ФТ */
  AmlCftCheck = 'AmlCftCheck',
  /** Ожидание проверки правлением */
  PendingBoardReview = 'PendingBoardReview',
  /** Проверка правлением */
  BoardReview = 'BoardReview',
  /** Подписание анкеты */
  SigningQuestionnaire = 'SigningQuestionnaire',
  /** Подписание документов */
  SigningDocuments = 'SigningDocuments',
  /** Ожидание открытия счета */
  AwaitingAccountOpening = 'AwaitingAccountOpening',
  /** Открытие счета */
  AccountOpening = 'AccountOpening',
  /** Счет открыт */
  AccountOpened = 'AccountOpened',
  /** Отказано в открытии счета */
  AccountOpeningDenied = 'AccountOpeningDenied',
}
